<script lang="babel">
export default{
  data () {
    return {
      modal: false,
      date: null
    }
  },
  computed: {
    computedFormatDate () {
      return this.formatDate(this.date)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    }
  }
}
</script>
<template lang="pug">
div
  v-toolbar(
    color="primary"
    dark
    app
    fixed
    )
    v-toolbar-side-icon
    v-toolbar-title Molinor
    v-spacer
    v-btn(
      flat
      @click="$router.push('/login')"
    ) Iniciar sessión
    v-btn(icon)
      v-icon more_vert
  v-content
    v-container(
      fluid
      fill-height
      )
      v-layout(
        align-center
        justify-center
        )
        v-flex(
          sm12
          md4
          sm8)
          v-card(class="elevation-12")
            v-toolbar(
              dark
              color="primary"
            )
              v-toolbar-title Consulta de Documento
            v-card-text
              v-form
                v-container(grid-list-sm)
                  v-layout(
                    row
                    wrap
                    )
                    v-flex(sm12)
                      v-select(label="Tipo de documento")
                    v-flex(sm4)
                      v-text-field(
                        label="Serie"
                      )
                    v-spacer
                    v-flex(sm6)
                      v-text-field(
                        label="Número correlativo"
                      )
                    v-flex(sm5)
                      v-dialog(
                        ref="dialog"
                        v-model="modal"
                        persistent
                        lazy
                        :return-value.sync="date"
                        width="290px"
                        )
                        v-text-field(
                          v-model="computedFormatDate"
                          label="Fecha de emisión"
                          slot="activator"
                          readonly
                          )
                        v-date-picker(
                          v-model="date"
                          locale="pe"
                          full-width
                          scrollable)
                          v-spacer
                          v-btn(
                            @click="modal = !modal"
                            flat
                            color="primary") Cancelar
                          v-btn(
                            @click="$refs.dialog.save(date)"
                            flat
                            color="primary"
                            ) OK
                    v-spacer
                    v-flex(sm5)
                      v-text-field(
                        label="Monto total"
                        )
            v-card-actions
              v-spacer
              v-btn(color="primary") Consultar
</template>
